import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import apiClient from '../../api/axios';

const DriverTestConnection = () => {
  const [connectionStatus, setConnectionStatus] = useState({
    api: 'checking',
    testData: 'checking',
    drivers: 'checking',
    orders: 'checking'
  });

  const [testResults, setTestResults] = useState({});

  useEffect(() => {
    testConnections();
  }, []);

  const testConnections = async () => {
    const results = {};

    // Test 1: Health Check
    try {
      const healthResponse = await apiClient.get('/driver-test-enhanced/health-check');
      setConnectionStatus(prev => ({ ...prev, api: 'connected' }));
      results.health = healthResponse.data;
      toast.success('✅ API connection successful');
    } catch (error) {
      setConnectionStatus(prev => ({ ...prev, api: 'failed' }));
      results.health = { error: error.message };
      toast.error('❌ API connection failed');
    }

    // Test 2: Create Test Data (simplified)
    try {
      const testDataResponse = await apiClient.post('/driver-test-enhanced/create-test-data-simple');
      setConnectionStatus(prev => ({ ...prev, testData: 'created' }));
      results.testData = testDataResponse.data;
      toast.success('✅ Test data check completed');
    } catch (error) {
      setConnectionStatus(prev => ({ ...prev, testData: 'failed' }));
      results.testData = { error: error.message };
    }

    // Test 3: Get Drivers
    try {
      const driversResponse = await apiClient.get('/driver-test-enhanced/all-drivers');
      setConnectionStatus(prev => ({ ...prev, drivers: 'loaded' }));
      results.drivers = driversResponse.data;
      toast.success('✅ Drivers loaded');
    } catch (error) {
      setConnectionStatus(prev => ({ ...prev, drivers: 'failed' }));
      results.drivers = { error: error.message };
    }

    // Test 4: Get Orders
    try {
      const ordersResponse = await apiClient.get('/driver-test-enhanced/all-orders');
      setConnectionStatus(prev => ({ ...prev, orders: 'loaded' }));
      results.orders = ordersResponse.data;
      toast.success('✅ Orders loaded');
    } catch (error) {
      setConnectionStatus(prev => ({ ...prev, orders: 'failed' }));
      results.orders = { error: error.message };
    }

    setTestResults(results);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'checking':
        return <span className="badge bg-warning">Checking...</span>;
      case 'connected':
      case 'created':
      case 'loaded':
        return <span className="badge bg-success">✅ Success</span>;
      case 'failed':
        return <span className="badge bg-danger">❌ Failed</span>;
      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">
                <i className="ri-wifi-line me-2"></i>
                Driver API Connection Test
              </h5>
            </div>
            <div className="card-body">
              <div className="row mb-4">
                <div className="col-md-3">
                  <div className="card border-primary">
                    <div className="card-body text-center">
                      <h6>API Health</h6>
                      {getStatusBadge(connectionStatus.api)}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card border-info">
                    <div className="card-body text-center">
                      <h6>Test Data</h6>
                      {getStatusBadge(connectionStatus.testData)}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card border-success">
                    <div className="card-body text-center">
                      <h6>Drivers</h6>
                      {getStatusBadge(connectionStatus.drivers)}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card border-warning">
                    <div className="card-body text-center">
                      <h6>Orders</h6>
                      {getStatusBadge(connectionStatus.orders)}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <button 
                    className="btn btn-primary me-2"
                    onClick={testConnections}
                  >
                    <i className="ri-refresh-line me-1"></i>
                    Retest Connections
                  </button>
                  <a href="/driver-test/login" className="btn btn-success">
                    <i className="ri-login-circle-line me-1"></i>
                    Go to Driver Login
                  </a>
                </div>
              </div>

              {Object.keys(testResults).length > 0 && (
                <div className="mt-4">
                  <h6>Test Results:</h6>
                  <pre className="bg-light p-3 rounded" style={{ fontSize: '12px', maxHeight: '400px', overflow: 'auto' }}>
                    {JSON.stringify(testResults, null, 2)}
                  </pre>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverTestConnection; 